import { defineMessages } from 'react-intl-next';

export const messages: {
	displayTextError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	displayTextLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	displayTextPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	displayTextLabel: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.display-text-label',
		defaultMessage: 'Display text',
		description: 'Label for the display text input',
	},
	displayTextPlaceholder: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder',
		defaultMessage: 'Item name',
		description: 'Placeholder text for the display text input',
	},
	displayTextError: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.display-text-error',
		defaultMessage: 'Please fill out this field.',
		description: 'Error text for the display text input',
	},
});
